import React, { useState } from "react";
import cl from "classnames";
import styled from "styled-components";
import { Link, useLocation } from "react-router";
import { useTranslation } from "react-i18next";
import { v4 as uuidv4 } from "uuid";

//
import Select from "../select/Select";
import LangList from "../../assets/data/lang-list";
import Logo from "../logo/Logo";
import { CONST_NAMES } from "../../config/constants";
import NavSelect from "../nav-select/NavSelect";
import NavbarPhoneContacts from "./NavbarPhoneContacts";

const NAVABOUTUSLIST = [
  {
    id: uuidv4(),
    title: "footerAboutClinic",
    to: "/about/clinic",
  },
  {
    id: uuidv4(),
    title: "footerAboutDoctor",
    to: "/about/doctor",
  },
  {
    id: uuidv4(),
    title: "footerAboutEyeDisease",
    to: "/about/eye-disease",
  },
  {
    id: uuidv4(),
    title: "footerAboutReview",
    to: "/about/review",
  },
  {
    id: uuidv4(),
    title: "footerAboutFAQ",
    to: "/about/faq",
  },
];

const NAVSERVICELIST = [
  {
    id: uuidv4(),
    title: "footerServiceAll",
    to: "/service/all",
  },
  {
    id: uuidv4(),
    title: "footerServiceEyeFullCheck",
    to: "/service/1",
  },
  {
    id: uuidv4(),
    title: "footerServiceContactLensCheck",
    to: "/service/2",
  },
  {
    id: uuidv4(),
    title: "footerServiceFullOpticCheck",
    to: "/service/3",
  },
  {
    id: uuidv4(),
    title: "footerServiceEyeCare",
    to: "/service/4",
  },
];

export default function Navbar() {
  const { t, i18n } = useTranslation();
  const { pathname } = useLocation();

  const [hoveredItem, setHoveredItem] = useState("");

  function handleChangeLang(lang) {
    i18n.changeLanguage(lang);
    window.localStorage.setItem(CONST_NAMES.SYSTEM_LANGUAGE, lang);
  }

  function checkForActive(path, key) {
    if (key === "/") {
      return path === key;
    }
    return path.includes(key);
  }

  function changeHoveredItem(v) {
    setHoveredItem(v);
  }

  return (
    <StyledNavbar>
      <div className="container">
        <div className="nav__wrap">
          <div className="nav__left">
            <Logo />
          </div>
          <div className="nav__mid">
            <ul className="nav__list">
              <li>
                <Link
                  to="/"
                  className={cl("", {
                    active: checkForActive(pathname, "/"),
                  })}
                >
                  {t("navHome")}
                </Link>
              </li>
              <li
                className={cl("hover_after", {
                  isActiveAfter: hoveredItem === "about",
                })}
                onMouseEnter={() => changeHoveredItem("about")}
                onMouseLeave={() => changeHoveredItem("")}
              >
                <Link
                  to={pathname}
                  className={cl("", {
                    active: checkForActive(pathname, "/about"),
                  })}
                >
                  {t("navAbout")}
                </Link>
                <i className="icon icon-arrow-down-s"></i>
                <NavSelect
                  list={NAVABOUTUSLIST}
                  isHidden={hoveredItem === "about" ? false : true}
                />
              </li>
              <li
                className={cl("hover_after", {
                  isActiveAfter: hoveredItem === "service",
                })}
                onMouseEnter={() => changeHoveredItem("service")}
                onMouseLeave={() => changeHoveredItem("")}
              >
                <Link
                  to={pathname}
                  className={cl("", {
                    active: checkForActive(pathname, "/service"),
                  })}
                >
                  {t("navService")}
                </Link>
                <i className="icon icon-arrow-down-s"></i>
                <NavSelect
                  list={NAVSERVICELIST}
                  isHidden={hoveredItem === "service" ? false : true}
                />
              </li>
              <li>
                <Link
                  to="/contact"
                  className={cl("", {
                    active: checkForActive(pathname, "/contact"),
                  })}
                >
                  {t("navContact")}
                </Link>
              </li>
            </ul>
          </div>
          <div className="nav__right">
            <Select
              value={i18n.language}
              options={LangList}
              onChange={handleChangeLang}
            />
            <NavbarPhoneContacts />
            <div className="nav__mobileBurger"></div>
          </div>
        </div>
      </div>
    </StyledNavbar>
  );
}

const StyledNavbar = styled.nav`
  background-color: var(--dark-blue);
  padding: 16px 0;
  box-shadow: 0px 3px 9px 5px rgba(8, 0, 115, 0.32);

  .nav {
    &__wrap {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

    &__left {
      display: flex;
      align-items: center;
    }

    &__list {
      display: flex;
      align-items: center;
      gap: 48px;

      li {
        position: relative;
        display: flex;
        align-items: center;
        gap: 6px;

        i {
          width: 18px;
          height: 18px;
        }

        & > a {
          font-size: 16px;
          font-style: normal;
          font-weight: 500;
          line-height: 22px; /* 146.667% */
          position: relative;

          &::after {
            content: "";
            position: absolute;
            bottom: -12px;
            left: 50%;
            transform: translateX(-50%);
            width: 0%;
            height: 2px;
            background-color: var(--white);
            transition: 0.4s ease;
          }

          &.active {
            &::after {
              width: 95%;
            }
          }
        }

        &:hover {
          & > a {
            &::after {
              width: 95%;
            }
          }
        }

        &.hover_after {
          &::after {
            content: "";
            position: absolute;
            bottom: 0;
            left: 0;
            transform: translateY(100%);
            width: 100%;
            height: 44px;
            background-color: transparent;
            pointer-events: none;
          }
        }

        &.isActiveAfter {
          &::after {
            pointer-events: unset;
          }
        }
      }
    }

    &__right {
      display: flex;
      align-items: center;
      gap: 24px;

    }

    &__mobileBurger {
      display: none;
    }
  }
`;
